// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tab[data-v-17949e76]:not(.v-tab--active){color:#000!important}.large-icon[data-v-17949e76]{font-size:30px}.logo--scale-down[data-v-17949e76]{height:35px}.min-height--unset[data-v-17949e76]{min-height:unset!important}a[data-v-17949e76]:hover{background-color:#f8f8f8!important}@media(max-width:768px){.v-toolbar__extension[data-v-17949e76],[data-v-17949e76] .v-toolbar__content{padding:0!important}[data-v-17949e76] .container{padding-left:0!important}}", ""]);
// Exports
module.exports = exports;
